import React from 'react';

import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';

import { Lightbox } from 'primereact/lightbox';
import CanvasDraw from "react-canvas-draw";
import { Dialog } from 'primereact/dialog';

import servicioCfdi from '../servicios/ServicioCfdi'
import servicioArchivo from '../servicios/ServicioArchivos';
import servicioEnvioCorreo from '../servicios/ServicioEnvioCorreo';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioFormatos from '../servicios/ServicioFormatos';
import formatoEspanolEsMX from '../servicios/ServicioIdiomaFecha';
import './Iframe.css';
export class Cfdi extends React.Component {

    constructor() {        
        super();
        this.state = {
            errores: {},
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            fechaInicial: null,
            fechaFinal: null,
            cfdis: [],
            muestraBoton: 'none',
            criterio: {},
            iFrameSrc:null,
            firmaObjeto: {},
            modalConfirmacion: false,
            modalFirmaDigital: false,
            idCanvas: null
        }
    }

    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();

    }

    obtenerPagina() {
        let { paginacion, fechaInicial, fechaFinal } = this.state;
        const resultadoValidacion = this.validarFormulario();
        this.setState({ errores: resultadoValidacion });
        let fechas = [
            fechaInicial,
           fechaFinal
                   ]
        paginacion['between'] = fechas;
        
        
        if (!Object.keys(resultadoValidacion).length) {

            servicioCfdi.paginacion(paginacion).then((response) => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

                if (response.data.error === false)
                    this.setState({ paginacion: response.data.objeto, muestraBoton: 'block' });

            }).catch((error) => {
                if (error)
                    return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            });
        }
    }

    validarFormulario() {
        let { fechaInicial, fechaFinal } = this.state;
        const errores = {};

        if (!fechaInicial)
            errores.fechaInicial = "El campo es requerido";
        if (fechaInicial !== undefined && fechaInicial !== null)
            if (fechaInicial.length > 0 && new Date(fechaInicial).toString() === 'Invalid Date')
                errores.fechaInicial = "Fecha inválida";

        if (!fechaInicial)
            errores.fechaInicial = "El campo es requerido";
        if (fechaInicial !== undefined && fechaInicial !== null)
            if (fechaInicial.length > 0 && new Date(fechaInicial).toString() === 'Invalid Date')
                errores.fechaInicial = "Fecha inválida";
        return errores;
    };

    columnaSeleccionar = (rowData, column) => {
        return <div>
            <div>
                <Checkbox inputId={rowData.uuid} value={rowData} onChange={this.asignarCfdis.bind(this)} checked={this.state.cfdis.includes(rowData)}></Checkbox>
            </div>
        </div>;
    }

    columnaVerRecibo = (rowData, column) => {
        return <div>
            <div>            
                <Button icon="pi-md-remove-red-eye" type="button" tooltip="Ver recibo" onClick={(e) => this.visorPdf(column.rowData, 'pdf')}></Button>
            </div>
        </div>;
    }
    
    
    columnaDescargaPdf = (rowData, column) => {
        return <div>
            <div>
                <Button type="button" icon="pi-md-file-download" className="p-button-danger" name="pdf"
                    tooltip="Descargar pdf" onClick={(e) => this.generaDescarga(column.rowData, 'pdf')} >
                </Button>
            </div>
        </div>;
    }

    columnaDescargaXml = (rowData, column) => {
        return <div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-file-download" className="p-button-success" name="xml"
                    tooltip="Descargar xml" onClick={(e) => this.generaDescarga(column.rowData, 'xml')} >
                </Button>
            </div>            
        </div>;
    }

    visorPdf = (objeto, tipo) => {
        servicioArchivo.descargaArchivoComoBlob('/cfdi/descarga_comprobante.json?uuid=' + objeto.uuid + '&tipo=' + tipo)
            .then((response) => {
                this.setState({ iFrameSrc: URL.createObjectURL(response) });
                document.getElementById("btnVisorPdfTarget").click();
            }).catch((error) => {
                this.growl.show({ severity: 'error', summary: '', detail: error });
            });

    }

    columnaTotal = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData.subtotal)}</div>;
    }

    columnaDescuento = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData.descuento)}</div>;
    }

    columnaNeto = (rowData, column) => {
        return <div>
            {servicioFormatos.formatearModena(rowData.total)}
        </div>;
    }

    columnaFechaFinalPago = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaPago)}</div>;
    }

    asignarCfdis(e) {
        let { cfdis } = this.state;

        if (e.checked)
            cfdis.push(e.value);
        else
            cfdis.splice(cfdis.indexOf(e.value), 1);

        this.setState({ cfdis });

    }


    generaDescarga = (objeto, tipo) => {
        servicioArchivo.descargaArchivo('/cfdi/descarga_comprobante.json?uuid=' + objeto.uuid + '&tipo=' + tipo)
            .then((response) => {
                if (response !== "si")
                    return this.growl.show({ severity: 'error', summary: '', detail: response });
            });
    }

    enviarCfdis() {
        let { cfdis, criterio } = this.state;
        let listaEnvio = [];
        if (cfdis.length === 0)
            return this.growl.show({ life: 3000, severity: 'error', summary: 'error', detail: "Selecciona al menos un comprobante" });

        const resultadoValidacion = this.validarCorreo(criterio.correo);
        this.setState({ errores: resultadoValidacion });

        if (!Object.keys(resultadoValidacion).length) {

            cfdis.forEach(cfdi => {
                let correo = {};
                correo['correo'] = criterio.correo;
                correo['estatus'] = 0;
                correo['ttCfdi'] = cfdi;
                listaEnvio.push(correo);
            });
            servicioEnvioCorreo.enviar_cfdis_correo(listaEnvio).then((response) => {
                this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'Error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false)
                    this.resetEstados();
            }).catch((error) => { });
        }
    }
    resetEstados() {
        this.setState({ cfdi: [], criterio: {} })
    }
    validarCorreo(correo) {
        const errores = {};
        let regularCorreo = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/;
        if (!correo)
            errores.correo = "El campo es requerido";

        let correos = correo.split(',');
        correos.forEach(nuevoCorreo => {
            if (!regularCorreo.test(nuevoCorreo))
                errores.correo = "Correo o correos inválidos";
        })

        return errores;
    }

    columnaEnviarAmiCorreo = (rowData, column) => {
        return <Button icon="pi-md-email" className="deep-orange-btn" type="button" tooltip="Enviar a mi correo" onClick={this.eviarAmicorreo.bind(this, column.rowData)}></Button>;


    }

    eviarAmicorreo = (e, event) => {
        servicioEnvioCorreo.enviar_a_mi_correo(e).then(response => {
            if (response.data.error) {
                this.growl.show({ life: 3000, severity: 'error', summary: '', detail: response.data.mensaje });
            } else {
                this.growl.show({ life: 3000, severity: 'success', summary: '', detail: response.data.mensaje });

            }
        })
    }

    columnaFirmarRecibo = (rowData, column) => {
        if (rowData.firmaDigital == 0) {
            return <div>
                <Button icon="pi-md-thumb-up" className="p-button-warning" type="button" tooltip="Firmar recibo" onClick={this.firmarPdf.bind(this, column.rowData)}></Button>
            </div>;
        } else {
            return <div></div>
        }

    }

    firmarPdf = (e, objeto) => {
        console.log(e.id);
        this.setState({ idCanvas: e.id, firmaObjeto: e, modalFirmaDigital: true });
        //   document.getElementById("btnFirmarPdfTarget").click();

    }

    firmarReciboPdf = () => {
        let obj = JSON.parse(this.loadableCanvas.getSaveData());
        if (obj.lines.length == 0) {
            this.growl.show({ life: 3000, severity: 'error', summary: '', detail: "No has ingresado una firma" });
        } else {
            this.setState({ modalConfirmacion: true });
        }
    }

    firmarRecibo = () => {
        const { firmaObjeto } = this.state;
        var base64Data = btoa(this.loadableCanvas.canvas.drawing.toDataURL());
        servicioCfdi.guardarFirmaDigital({ uuid: firmaObjeto.uuid, direccionFirmaDigital: base64Data }).then(response => {
            if (response.data.error) {
                this.growl.show({ life: 3000, severity: 'error', summary: '', detail: response.data.mensaje });
            } else {
                this.setState({ firmaObjeto: {}, modalConfirmacion: false,modalFirmaDigital:false,idCanvas:null })
                this.growl.show({ life: 3000, severity: 'success', summary: '', detail: response.data.mensaje });
                this.obtenerPagina();
            }
        })
    }

    cerrarCanvasFirmaRecibo = () => {
        this.setState({modalFirmaDigital: false,idCanvas:null});
     }

    asignarValores(event) {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }

    render() {

        let { errores, fechaInicial, fechaFinal, paginacion, inicio, muestraBoton, criterio, iFrameSrc,idCanvas } = this.state;

        const visorPdfTarget = (
            <button id="btnVisorPdfTarget" className="p-link" style={{ visibility: "hidden" }}></button>
        );

        const footer = (
            <div className="p-grid">
                   <div className="p-col-12 p-md-6">
                   <Button label="Si estoy seguro" icon="pi pi-check" className="deep-orange-btn" onClick={this.firmarRecibo} />   
                   </div>
                   <div className="p-col-12 p-md-6">
                   <Button label="No estoy seguro" icon="pi pi-times" className="p-button-danger" onClick={() => this.setState({ modalConfirmacion: false })} />   
                   </div>
                
            </div>
        );
        return (
            <div className="p-grid">
                <Growl ref={(el) => this.growl = el} />

                <Lightbox target={visorPdfTarget}>
                    <div id="contenedorIframe"  >
                        <iframe id="elIframe" src={iFrameSrc} frameBorder="0" className="iframeEstilo" ></iframe>
                    </div>
                </Lightbox>

                <Dialog header="Firma Digital"  className="modalFirmaDigital" visible={this.state.modalFirmaDigital} modal={true} onHide={() => this.setState({ modalFirmaDigital: false,idCanvas:null })}>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12">
                            <CanvasDraw key={idCanvas}
                                ref={canvasDraw => (this.loadableCanvas = canvasDraw)}
                                style={{
                                    boxShadow:
                                        "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)"
                                }}
                                immediateLoading={true}
                                lazyRadius={1}
                                brushRadius={2}
                                className="firmaDigital"
                            />

                        </div>
                        <div className="p-col-12 p-md-4">
                            <Button type="button" label="Firmar Recibo" icon="pi-md-verified-user" className="deep-orange-btn" onClick={this.firmarReciboPdf}></Button>

                        </div>
                        <div className="p-col-12 p-md-4">
                            <Button type="button" label="Limpiar Firma" icon="pi-md-content-cut" className="teal-btn" onClick={() => { this.loadableCanvas.clear() }}></Button>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <Button type="button" label="Cancelar" icon="pi-md-clear" className="p-button-danger" onClick={this.cerrarCanvasFirmaRecibo}></Button>
                        </div>

                    </div>
                </Dialog>

                <Dialog header="Confirmación" visible={this.state.modalConfirmacion} style={{ width: '50%' }} footer={footer} modal={true} onHide={() => this.setState({ modalConfirmacion: false })}>
                    ¿Estás seguro que tu firma está correcta?
               </Dialog>


                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Mis Recibos de Nómina</h1>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="fechaInicial">* Fecha Inicial</label>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <Calendar locale={formatoEspanolEsMX} id="fechaInicial" name="fechaInicial" className={errores.fechaInicial ? 'p-error' : ''} value={fechaInicial || ''} onChange={(e) => { this.setState({ fechaInicial: e.value }) }} showIcon={true} />
                                {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="fechaPago">* Fecha Final</label>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <Calendar locale={formatoEspanolEsMX} id="fechaFinal" name="fechaFinal" className={errores.fechaFinal ? 'p-error' : ''} value={fechaFinal || ''} onChange={(e) => { this.setState({ fechaFinal: e.value }) }} showIcon={true} />
                                {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-2">
                                <Button className="p-button-Primary p-button-raised" label="Buscar"
                                    icon="pi-md-search" tooltip={"Consultar comprobantes"} onClick={this.obtenerPagina.bind(this)} />
                            </div>

                            <div className="p-col-12 p-md-12">
                                <div style={{ display: muestraBoton }}>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6">
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon"><i className="material-icons">email</i></span>
                                                <InputText id="correo" name="criterio.correo" className={errores.correo ? 'p-error' : ''}
                                                    placeholder="ejemplo@dominio.com" tooltip="Para agregar más de un correo debes separarlo por una coma (,) seguido del nuevo correo "
                                                    value={criterio.correo || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                            </div>
                                            {errores.correo ? <div><br /> <Message severity="error" text={errores.correo} /> </div> : null}
                                        </div>

                                        <div className="p-col-12 p-md-6">
                                            <Button className="p-button-Primary p-button-raised" label="Enviar"
                                                onClick={this.enviarCfdis.bind(this)} icon="pi-md-mail" tooltip="Enviar a mi correo" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="p-col-12">
                    <div className="card card-w-title">
                        <DataTable value={paginacion.datos} selectionMode="single" responsive={true} header="Mis recibos de Nómina" >
                            <Column header="Seleccionar" body={this.columnaSeleccionar}  autoLayout={true}/>
                            <Column header="Ver Recibo" body={this.columnaVerRecibo}  autoLayout={true}/>
                            <Column header="Descarga Xml" body={this.columnaDescargaXml} autoLayout={true} />
                            <Column header="Descarga Pdf" body={this.columnaDescargaPdf}  autoLayout={true}/>
                            <Column header="Enviar a mi correo" body={this.columnaEnviarAmiCorreo} autoLayout={true} />
                            <Column header="Firmar Recibo" body={this.columnaFirmarRecibo} autoLayout={true} />
                            <Column field="uuid" header="Uuid"  style={{ width: '150px' }} autoLayout={true}/>
                            <Column header="Total" body={this.columnaTotal} autoLayout={true} />
                            <Column header="Descuento" body={this.columnaDescuento}  autoLayout={true}/>
                            <Column header="Neto" body={this.columnaNeto} autoLayout={true}/>
                            <Column header="Fecha de Pago" body={this.columnaFechaFinalPago} style={{ width: '150px' }} autoLayout={true}/>
                        </DataTable>
                        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                    </div>
                </div>
            </div>
        );
    }

}